import { Link } from 'react-router-dom';
import { articles, getHotArticles, getLatestArticles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

function HeroBanner() {
  const hotArticles = getHotArticles();
  const topArticle = hotArticles[0];

  return (
    <section className="relative h-[500px] md:h-[600px] flex items-end">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20newsroom%20with%20multiple%20glowing%20screens%20displaying%20breaking%20news%20headlines%2C%20warm%20red%20and%20orange%20accent%20lights%2C%20cinematic%20atmosphere%2C%20dramatic%20lighting%2C%20modern%20media%20center%2C%20professional%20broadcast%20studio%20aesthetic%2C%20dark%20background%20with%20warm%20highlights&width=1800&height=800&seq=home-hero-bg&orientation=landscape"
        alt="爆料专区 - 最新爆料资讯"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 pb-10 md:pb-14">
        <div className="max-w-4xl">
          <div className="flex items-center gap-2 mb-3">
            <span className="px-2.5 py-1 text-xs font-semibold bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
              今日头条
            </span>
            {topArticle?.isExclusive && (
              <span className="px-2.5 py-1 text-xs bg-background-50/20 text-background-50 rounded-full whitespace-nowrap">
                独家
              </span>
            )}
          </div>
          <h1 className="text-2xl md:text-4xl font-bold text-background-50 mb-3 leading-tight">
            <Link to={`/article/${topArticle?.id}`} className="hover:underline">
              {topArticle?.title || '欢迎来到爆料专区'}
            </Link>
          </h1>
          <p className="text-sm md:text-base text-background-50/80 mb-4 max-w-2xl line-clamp-2">
            {topArticle?.excerpt}
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/70">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i> {topArticle ? (topArticle.views / 10000).toFixed(0) + '万' : 0} 阅读
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line"></i> {topArticle?.comments || 0} 评论
            </span>
            <span>{topArticle?.publishDate}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

function BreakingNewsTicker() {
  const latestArticles = getLatestArticles(5);
  return (
    <div className="bg-accent-500/10 border-b border-accent-200/30">
      <div className="px-4 md:px-6 py-2.5 flex items-center gap-3">
        <span className="flex items-center gap-1 text-xs font-bold text-accent-600 whitespace-nowrap">
          <i className="ri-flashlight-line"></i> 快讯
        </span>
        <div className="flex-1 overflow-hidden">
          <div className="flex items-center gap-8 animate-marquee whitespace-nowrap">
            {latestArticles.map(article => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="text-sm text-foreground-700 hover:text-primary-500 transition-colors duration-200"
              >
                {article.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function CategoryGrid() {
  const displayCategories = categories.filter(c => c.slug !== 'all');
  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="mb-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950">爆料分类</h2>
        <p className="text-sm text-foreground-500 mt-2">按类别浏览你最感兴趣的爆料内容</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {displayCategories.map(cat => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 transition-all duration-300"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
              <i className={`${cat.icon} text-lg`}></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">{cat.name}</h3>
            <p className="text-xs text-foreground-500 line-clamp-1">{cat.description}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}

function HotCollection() {
  const hotArticles = getHotArticles();

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">今日热门爆料</h2>
          <p className="text-sm text-foreground-500 mt-2">全网最火爆的独家猛料，不容错过</p>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {hotArticles.map(article => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02]"
          >
            <div className="relative aspect-[16/9] overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              {article.isExclusive && (
                <span className="absolute top-3 left-3 px-2 py-0.5 text-xs bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
                  独家
                </span>
              )}
              {article.isVideo && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-950">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
              )}
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs text-primary-500 font-medium">
                  {categories.find(c => c.slug === article.category)?.name}
                </span>
                <span className="text-xs text-foreground-400">{article.publishDate}</span>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{article.excerpt}</p>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i> {(article.views / 10000).toFixed(1)}万
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line"></i> {article.comments}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

function LatestNews() {
  const latestArticles = getLatestArticles(9);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">最新爆料</h2>
          <p className="text-sm text-foreground-500 mt-2">每日更新，新鲜瓜料不断</p>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
        {latestArticles.slice(0, 2).map(article => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group flex flex-col sm:flex-row gap-4 bg-background-100 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.01]"
          >
            <div className="w-full sm:w-48 h-40 sm:h-auto flex-shrink-0 overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
            </div>
            <div className="flex-1 p-4 flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-primary-500 font-medium">
                    {categories.find(c => c.slug === article.category)?.name}
                  </span>
                  {article.isExclusive && (
                    <span className="px-1.5 py-0.5 text-xs bg-accent-100 text-accent-700 rounded whitespace-nowrap">独家</span>
                  )}
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2">{article.excerpt}</p>
              </div>
              <div className="flex items-center gap-3 text-xs text-foreground-400 mt-3">
                <span>{article.publishDate}</span>
                <span>{(article.views / 10000).toFixed(1)}万阅读</span>
                <span>{article.comments}评论</span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
        {latestArticles.slice(2, 5).map(article => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group bg-background-100 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02]"
          >
            <div className="relative aspect-[16/9] overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs text-primary-500 font-medium">
                  {categories.find(c => c.slug === article.category)?.name}
                </span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                {article.title}
              </h3>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

function StatsBar() {
  return (
    <section className="px-4 md:px-6 py-8 md:py-10 bg-accent-500">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
        {[
          { value: '10万+', label: '累计爆料' },
          { value: '500万+', label: '日活跃用户' },
          { value: '98%', label: '独家首发率' },
          { value: '24h', label: '全天候更新' },
        ].map((stat, i) => (
          <div key={i}>
            <div className="text-2xl md:text-3xl font-bold text-background-50 mb-1">{stat.value}</div>
            <div className="text-xs md:text-sm text-background-50/70">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default function HomePage() {
  const siteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '爆料专区',
    url: 'https://baoliao.example.com',
    description: '爆料专区汇集全网最新爆料、今日爆料及热门爆料合集，每日更新独家爆料视频与内幕猛料。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://baoliao.example.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爆料专区',
    url: 'https://baoliao.example.com',
    description: '爆料专区汇集全网最新爆料、今日爆料及热门爆料合集，每日更新独家爆料视频与内幕猛料。',
    email: 'contact@baoliao.example.com',
    telephone: '400-888-6666',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      streetAddress: '光华路甲1号',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(siteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />

      <HeroBanner />
      <BreakingNewsTicker />
      <CategoryGrid />
      <HotCollection />
      <StatsBar />
      <LatestNews />

      <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="text-center">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-3">你有猛料要爆？</h2>
          <p className="text-sm text-foreground-500 mb-6 max-w-lg mx-auto">
            如果你有独家内幕、行业黑幕或不为人知的故事，欢迎向爆料专区投稿。我们为爆料人提供最高级别的匿名保护。
          </p>
          <a
            href={`mailto:${import.meta.env.VITE_PUBLIC_CONTACT_EMAIL || 'contact@baoliao.example.com'}`}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            <i className="ri-mail-send-line"></i> 我要爆料
          </a>
        </div>
      </section>
    </>
  );
}